import { C } from "./component";
import { Requester } from "./requester";
import { AuthenticationHandler } from "./authentication-handler";
import { FormActionResultFile } from "../forms/form";

export class DownloadHelper
{
    static getFileDownloadUrl(url: string, parameters?: { [parameterName: string]: string })
    {
        if (!parameters)
        {
            parameters = {};
        }
        parameters[AuthenticationHandler.controlTokenParamName] = localStorage[AuthenticationHandler.controlTokenParamName];
        return Requester.getUrl(url, parameters);
    }

    static download(file: FormActionResultFile)
    {
        const extension = file.Name.split(".").pop();
        const content = `data:application/${extension};base64,${file.Content}`;
        const downloadLink = C.a.attr("href", content).attr("download", file.Name).appendTo(C.body);
        downloadLink[0].click();
        downloadLink.remove();
    }
}
